'use client';

import { useParams } from 'next/navigation';

import da from '../../../public/locales/da/not-found.json';
import de from '../../../public/locales/de/not-found.json';
import en from '../../../public/locales/en/not-found.json';
import es from '../../../public/locales/es/not-found.json';
import fr from '../../../public/locales/fr/not-found.json';
import nl from '../../../public/locales/nl/not-found.json';
import no from '../../../public/locales/no/not-found.json';
import pl from '../../../public/locales/pl/not-found.json';
import sv from '../../../public/locales/sv/not-found.json';
import { NotFoundCopy, NotFoundSection } from './NotFoundSection';

const COPY: Record<string, NotFoundCopy> = { da, de, en, es, fr, nl, no, pl, sv };

/**
 * The 404 section for `notFound()` thrown inside a route (app/[locale]/not-found.tsx). That file's
 * element is serialized into the RSC payload of EVERY page under [locale] (it's a prop of the
 * layout router), so it carries no server-rendered header/footer or per-locale copies — just this
 * reference; the copy (~2 kB for all locales) lives in this chunk and is picked by the URL locale.
 */
export const NotFoundFallback = () => {
  const params = useParams<{ locale?: string }>();
  const locale = params?.locale && COPY[params.locale] ? params.locale : 'en';
  return <NotFoundSection copy={COPY[locale]} locale={locale} />;
};
